import React from 'react'
import { SuccessContent, SuccessSubTitle } from './style'
import { EExternalLinks } from 'types/enums/EExternalLinks'
import { setFormTranslatedText } from 'pages/auth/utils/setFormTranslatedText'
import { useTranslation } from 'react-i18next'
import { Button } from 'shared/components/button/Button'

export const SuccessPage: React.FC = () => {
  const { t } = useTranslation('', {
    keyPrefix: `pages.success`,
  })
  setFormTranslatedText('success')

  return (
    <>
      <SuccessContent>
        <SuccessSubTitle>{t('welcome')}</SuccessSubTitle>
      </SuccessContent>
      <Button
        type="submit"
        text={t('buttons.official-website.text')}
        callback={() => window.open(EExternalLinks.HJBC)}
      />
    </>
  )
}
